import { apiClient } from './client';
import type { ClientsPageMeta } from './clients';

/**
 * Объявление (вкладка "Объявления" раздела «Маркетинг») — GET/POST/PUT/DELETE
 * /ads (см. докблок AdController в Laravel, 1:1 старые Orchid-экраны
 * AdListScreen/AdEditScreen).
 */
export interface AdMedia {
  id: number;
  url: string | null;
  /** Отображаемое имя (attachments.original_name) — правится пользователем. */
  name: string | null;
  alt: string | null;
  description: string | null;
  mime: string | null;
}

/** Параметры медиафайла: отображаемое имя, альтернативный текст, описание. */
export interface UpdateMediaPayload {
  name: string;
  alt?: string | null;
  description?: string | null;
}

export interface AdRow {
  id: number;
  name: string;
  /** HTML текста объявления (в Orchid — Quill-поле ad.description). */
  description: string | null;
  dateFrom: string | null;
  dateTo: string | null;
  active: boolean;
  media: AdMedia | null;
}

export interface FetchAdsParams {
  search?: string;
  page?: number;
  /** '1' | '0' — фильтр по статусу показа; undefined — все. */
  active?: string;
}

export interface AdsPage {
  items: AdRow[];
  meta: ClientsPageMeta;
}

export async function fetchAds(params: FetchAdsParams = {}): Promise<AdsPage> {
  const { data } = await apiClient.get<AdsPage>('/ads', { params });
  return data;
}

export interface SaveAdPayload {
  name: string;
  description?: string | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  active: boolean;
  /** id вложения из uploadAdMedia(); null — снять файл. */
  mediaId?: number | null;
}

export async function createAd(payload: SaveAdPayload): Promise<AdRow> {
  const { data } = await apiClient.post<AdRow>('/ads', payload);
  return data;
}

export async function updateAd(id: number, payload: SaveAdPayload): Promise<AdRow> {
  const { data } = await apiClient.put<AdRow>(`/ads/${id}`, payload);
  return data;
}

export async function deleteAd(id: number): Promise<void> {
  await apiClient.delete(`/ads/${id}`);
}

/** Файл грузится отдельным запросом до сохранения формы — как это делал Upload-виджет в Orchid. */
export async function uploadAdMedia(file: File): Promise<AdMedia> {
  const form = new FormData();
  form.append('file', file);
  const { data } = await apiClient.post<AdMedia>('/ads/media', form);
  return data;
}

export async function updateAdMedia(mediaId: number, payload: UpdateMediaPayload): Promise<AdMedia> {
  const { data } = await apiClient.put<AdMedia>(`/ads/media/${mediaId}`, payload);
  return data;
}

/** Включение/отключение из списка — отдельный маршрут, без валидации всей записи. */
export async function setAdActive(id: number, active: boolean): Promise<AdRow> {
  const { data } = await apiClient.put<AdRow>(`/ads/${id}/active`, { active });
  return data;
}
